/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressV1Dto } from './AddressV1Dto';
import type { ContactPersonToCustomerV1Dto } from './ContactPersonToCustomerV1Dto';
import type { CustomerBankingAccountV1Dto } from './CustomerBankingAccountV1Dto';
import type { PartnerBankingAccountV1Dto } from './PartnerBankingAccountV1Dto';
export type CustomerV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * The name of the customer.
   */
  name: string;
  /**
   * The country of the customer.
   */
  country: string;
  /**
   * The accounting area of the customer (Buchungskreis).
   */
  accountingArea?: string | null;
  /**
   * The VAT number of the customer (Umsatzsteuer-Identifikationsnummer).
   */
  vat?: string | null;
  /**
   * The language of correspondence with the customer.
   */
  languageOfCorrespondence?: CustomerV1Dto.languageOfCorrespondence | null;
  /**
   * The uuid of the customer-group linked to this customer. As 8-4-4-4-12 format.
   */
  customerGroupId?: string | null;
  /**
   * the default vat rate in percent of the customer.
   */
  vatRate?: number;
  /**
   * Indicates if the customer is a group admin.
   */
  isGroupAdmin: boolean;
  /**
   * The the address linked to this customer.
   */
  addresses?: Array<AddressV1Dto> | null;
  /**
   * Contact persons associated with the customer
   */
  contactPersonToCustomer?: Array<ContactPersonToCustomerV1Dto> | null;
  /**
   * Banking accounts for the customer
   */
  bankingAccounts?: Array<CustomerBankingAccountV1Dto> | null;
  /**
   * Partner banking accounts for the customer
   */
  partnerBankingAccounts?: Array<PartnerBankingAccountV1Dto> | null;
};
export namespace CustomerV1Dto {
  /**
   * The language of correspondence with the customer.
   */
  export enum languageOfCorrespondence {
    GERMAN = 'german',
    ENGLISH = 'english',
  }
}
